import { TabFallback } from '@/components/TabFallback';
import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { RouteHandle } from './types';

// Lazy-load so `/submissions` doesn't bloat the initial bundle. Matches the
// convention established by every other top-level route module.
const MySubmissions = lazy(() =>
  import('@/pages/MySubmissions').then((m) => ({ default: m.MySubmissions })),
);

/**
 * `My submissions` — authenticated-only. Row-level scoping is enforced
 * server-side (T16a): every signed-in caller sees only their own
 * submissions. `requiredPermissions: []` deliberately holds an empty list —
 * no flat permission gates this page; the API's row-level scope is the
 * single authoritative gate.
 */
const handle: RouteHandle = {
  crumb: 'My submissions',
  requiredPermissions: [],
};

export const submissionsRoutes: RouteObject[] = [
  {
    path: 'submissions',
    element: (
      <Suspense fallback={<TabFallback />}>
        <MySubmissions />
      </Suspense>
    ),
    handle,
  },
];
